<div class="body-content">
    <div class="center-container">
        <div class="content-area">
            <!-- Stepper - Sidebar -->
            <div class="sidebar">
                <div *ngIf="!isEditMode" class="role-title">Create a new scenario</div>
                <div *ngIf="isEditMode" class="role-title">Editing {{ scenario_name }}</div>
                <app-stepper [isEditMode]="isEditMode" (changeStepperEvent)="changeStepper($event)"></app-stepper>
            </div>
            <!-- Form Elements-->
            <div class="container">
                <!-- Form Elements-->
                <div class="inner-container">
                    <form [formGroup]="step1Form" class="landing-stepper">
                        <div class="title">
                            <div class="tell-us-block">
                                <span class="paraTell">Select Customer Profile</span>
                            </div>
                            <div class="inner-block">
                                <div class="doctor-big">
                                    <div class="left-arrow">
                                        <div class="left-arrow-container" (click)="previousProfile()"
                                            *ngIf="currentProfileId>0">
                                            <img src="../../../assets/images/fluent_arrow-up-12-regular.svg"
                                                alt="Arrow Black" />
                                        </div>
                                    </div>
                                    <div class="profile-big">
                                        <img [src]="profiles[currentProfileId].avatar_url" alt="Customer" />

                                    </div>
                                    <div class="right-arrow">
                                        <div class="right-arrow-container" (click)="nextProfile()"
                                            *ngIf="currentProfileId < profileLength">
                                            <img src="../../../assets/images/fluent_arrow-up-12-regular.svg"
                                                alt="Arrow Black" />
                                        </div>
                                    </div>
                                </div>
                                <div class="top-block">
                                    <div class="cust row-1">
                                        <div class="name">
                                            <label class="labels" for="customerName">Customer Name:</label>
                                            <input class="input-box" type="text" formControlName="customerName"
                                                id="customerName" placeholder="Enter customer name" readonly>
                                        </div>
                                        <div class="toggle">
                                            <label class="labels" for="avatar">Avatar enabled</label>
                                            <mat-slide-toggle formControlName="avatar"></mat-slide-toggle>
                                        </div>


                                    </div>
                                    <div class="row-2">
                                        <div class="cust">
                                            <label class="labels" for="age">Age:</label>
                                            <input class="input-box" type="text" formControlName="age" id="age"
                                                placeholder="Enter age" readonly>
                                        </div>
                                        <div class="cust">
                                            <label class="labels" for="occupation">Occupation:</label>
                                            <input class="input-box" type="text" formControlName="occupation"
                                                id="occupation" placeholder="Enter occupation" readonly>
                                        </div>
                                    </div>
                                </div>
                                <div class="bottom-block">
                                    <div class="cust">
                                        <label class="labels">Career Highlights:</label>
                                    </div>
                                    <div class="checkbox-list">
                                        <div *ngFor="let item of careerHighlights; let i=index;"
                                            formArrayName="careerHighlights" class="bb-cl">
                                            <label [ngClass]="item.checked ? 'item-selected' : ''">
                                                <input type="checkbox" [value]="item.id" [checked]="item.checked"
                                                    [formControlName]="i">
                                                {{ item.label }}
                                            </label>
                                        </div>
                                    </div>

                                    <div class="cust">
                                        <label class="labels">Professional Goals</label>
                                    </div>
                                    <div class="checkbox-list">
                                        <div *ngFor="let item of professionalGoals; let i=index;"
                                            formArrayName="professionalGoals" class="bb-cl">
                                            <label [ngClass]="item.checked ? 'item-selected' : ''">
                                                <input type="checkbox" [value]="item.id" [checked]="item.checked"
                                                    [formControlName]="i">
                                                {{ item.label }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="cancel-button" (click)="goBack()">&times;</div>
        </div>

        <div class="footer-step1">
            <div class="primary-button" (click)="goToStep(2)">
                <div>Next</div>
            </div>
        </div>
    </div>
</div>